import buttons from './tagInput.vue';

export default buttons;
